import DeleteButton from 'CMFW/button/DeleteButton';
import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import TextInput from 'CMFW/input/TextInput';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorGap,
  EditorRow,
  ModuleContainer,
} from 'components/common/styles';
import ListIds from 'components/common/ListIds';
import { Split } from 'components/Split';
import { IRefIds } from 'constants/refs';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo } from 'react';
import { WordClassSelect } from '../../../components/selects/WordClassSelect';
import ActiveInflectTemplatesModel from '../../../models/ActiveInflectTemplatesModel';
import ActiveInflectCells from '../components/ActiveInflectCells';
import TextSearch from '../../../components/search/TextSearch';

export type IProps = {
  courseId: number;
};

const ActiveInflectTemplates: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const activeInflectTemplatesModel = useMemo(
    () =>
      new ActiveInflectTemplatesModel({
        render: forceRender,
        courseId: props.courseId,
      }),
    [props.courseId, forceRender],
  );

  const templateId = activeInflectTemplatesModel.getItemUpdatedValue('id');
  const wordClassId = activeInflectTemplatesModel.getItemUpdatedValue('wordClass');

  const isEditingExistingTemplate = templateId !== activeInflectTemplatesModel.DIFFERENT_NEW_ID;

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={activeInflectTemplatesModel}>
        <Split widthLeft={484}>
          <ContainerLeft>
            <TextSearch />
            <Grid />
            <ContainerLeftFooter>
              <ReloadButton />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <EditorRow>
                <TextInput keyName={'name'} label={'name'} />
                <EditorGap />
                <SaveButton />
              </EditorRow>
              <EditorRow>
                <WordClassSelect isLinked onChange={forceRender} disabled={isEditingExistingTemplate} finalOnly />
              </EditorRow>
              <EditorGap />
              <ListIds keyName={'panels'} refId={IRefIds.panels} label={'Panels'} />
              <EditorGap />
              <ActiveInflectCells courseId={props.courseId} templateId={templateId} wordClassId={wordClassId} />
              <DeleteButton />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default ActiveInflectTemplates;
